import { LandingPageView } from "../components/LandingPageView";
import { useLandingSpaces } from "../hooks/useLandingSpaces";

/** Route entry — wires landing data into the presentation component */
export function LandingPage() {
  const { spaces, isLoading, error, retry } = useLandingSpaces();
  return (
    <LandingPageView
      spaces={spaces}
      isLoading={isLoading}
      error={error}
      onRetry={retry}
    />
  );
}
